import axios from 'axios'
import Component from 'Scripts/classes/Component'
import gsap from 'gsap'
import { getCookieValue } from 'Scripts/utils/utils'
import { dataByLang } from 'Scripts/utils/lang'
export default class extends Component {
  constructor({ form, fields, submit }) {
    super({
      container: form,
      elements: fields,
    })
    //Variables
    this.fieldsCount = Object.keys(this.elements).length
    this.submit = submit instanceof HTMLElement ? submit : document.querySelector(submit)
    this.formData = new FormData()
    this.lang = getCookieValue('wp-wpml_current_language') || 'fr'
    //Methods
    this.container.reset()
    this.init()
    this.addAutoResize()
  }

  init() {
    this.submit.addEventListener('click', (e) => {
      e.preventDefault()
      //RUN RULES ON SUBMIT BUTTON CLICK
      this.runRules(e)
      //BIND EVENTS TO EACH INPUT FIELD
      // for (const [key, input] of Object.entries(this.elements)) {
      for (const input of Object.values(this.elements)) {
        const parent = input.closest('.form__item')
        input.addEventListener('focus', (e) => {
          this.runRules(e)
        })

        parent.addEventListener('click', () => {
          this.resetErrors(parent)
        })
      }
    })

    this.container.querySelectorAll('input[type=file]').forEach((elm) => {
      const parent = elm.closest('.form__item')
      const loader = parent.querySelector('.loader')
      const info = parent.querySelector('.file__info')

      this.resetFileInput(elm)
      elm.addEventListener(
        'change',
        async (e) => {
          this.resetFileInput(elm)
          setTimeout(async () => {
            const response = await this.uploadFile(elm)
            this.formData.set(elm.name, response.data.id)
            parent.querySelector('.file__title').innerText = e.target.files[0].name

            gsap.set(info, { autoAlpha: 1 })
            gsap.to(loader, {
              left: '100%',
              duration: 1,
              ease: 'Power1.inOut',
            })
          }, 400)
        },
        false
      )
    })
  }

  resetFileInput(input) {
    const parent = input.closest('.form__item')
    const loader = parent.querySelector('.loader')
    const info = parent.querySelector('.file__info')
    gsap.set(info, { autoAlpha: 0 })
    gsap.set(loader, { left: '0%', width: 0 })
  }

  async checkFields() {
    this.validCount = 0

    // console.log(Object.entries(this.elements),Object.values(this.elements))
    // for (const [key, input] of Object.entries(this.elements)) {
    for (const input of Object.values(this.elements)) {
      if (input.required && input.value.trim() === '') {
        this.setErrorFor(input, dataByLang[this.lang].formField || 'this field cannot be blank')
      } else if (input.type == 'email' && !this.isEmail(input.value.trim())) {
        this.setErrorFor(input, dataByLang[this.lang].emailField || 'Not a valid email')
      } else if (
        input.type == 'url' &&
        input.value.trim() !== '' &&
        !this.isUrl(input.value.trim())
      ) {
        this.setErrorFor(input, dataByLang[this.lang].urlField || 'Not a valid URL')
      } else {
        // if (input.type == "file" && input.files.length > 0) {
        //   const res = await this.uploadFile(input)
        //   this.formData.append(input.name, res.data.id)
        //   input.closest('.form__item').querySelector('.file__title').innerText= "toto"
        // } else {
        //   this.formData.append(input.name, input.value)
        // }

        if (input.type !== 'file') {
          this.formData.append(input.name, input.value)
        }

        this.setSuccessFor(input)
        this.validCount += 1
      }
    }

    if (this.validCount === this.fieldsCount) {
      //SUBMIT FORM
      this.submitForm()
    }
  }

  async uploadFile(input) {
    const fileData = new FormData()
    fileData.append('file', input.files[0])
    // fileData.append('endpoint', 'media')
    // const response = await axios.post(`${process.env.SGTMAPI}/proxy`, fileData, {
    const response = await axios.post(`${process.env.API}/media`, fileData, {
      withCredentials: true,
      onUploadProgress: (e) => {
        let percent = Math.floor((e.loaded * 100) / e.total)
        input.closest('.form__item').querySelector('.loader').style.width = `${percent}%`
      },
    })

    return response
  }

  runRules(evnt) {
    const target = evnt.target,
      type = evnt.type

    //IF EVENT ON SUBMIT BUTTON
    if (target === this.submit) {
      //PREVENT FORM SUBMITTION
      evnt.preventDefault()
      //IF INPUT HAS FOCUS
    } else if (type === 'focus') {
      //RESET CLASSLIST
      this.resetClassList(target)
      //RESET ERRORS
      this.resetErrors(target)
      return false
    }
    //RESET CLASSLIST
    this.resetClassList()
    //CHECK FIELDS
    this.checkFields()
  }

  resetClassList(input) {
    //IF TARGETING SPECIFIC INPUT
    if (input) {
      //REMOVE CLASSES
      input.closest('.form__item').classList.remove('success', 'error')
      //FOCUS ON INPUT FIELD
      input.focus()
    } else {
      //REMOVE CLASSES FROM ALL FIELDS
      // for (const [key, input] of Object.entries(this.elements)) {
      for (const input of Object.values(this.elements)) {
        // input.parentElement.classList.remove("success", "error")
        input.closest('.form__item').classList.remove('success', 'error')
      }
    }
  }

  resetErrors(input) {
    //IF CONTAINER CONTAINS ERROR
    if (input.closest('.form__item').classList.contains('error')) {
      //RESET CLASSES
      this.resetClassList(input)
    }
  }

  setErrorFor(input, message) {
    const formControl = input.closest('.form__item')
    const small = formControl.querySelector('small')
    formControl.classList.remove('success')
    formControl.classList.add('error')
    small.innerText = message
  }

  setSuccessFor(input) {
    const formControl = input.closest('.form__item')
    const small = formControl.querySelector('small')
    formControl.classList.remove('error')
    formControl.classList.add('success')
    small.innerText = ''
  }

  isEmail(email) {
    // return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    )
  }

  isUrl(url) {
    return /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/.test(url)
  }

  isPhone(phone) {
    return /^\d+$/.test(phone)
  }

  submitForm() {
    // this.container.dispatchEvent(new CustomEvent('submit', { cancelable: true }))
    // for (const [key, input] of Object.entries(this.elements)) {
    //   this.formData.append(input.name, input.value)
    // }
    // this.formData = new FormData(this.container)
    this.container.dispatchEvent(new CustomEvent('submitform', { cancelable: true }))
  }

  addAutoResize() {
    // document.querySelectorAll('[data-autoresize]').forEach(function (element) {
    document.querySelectorAll('textarea').forEach(function (el) {
      el.style.boxSizing = 'border-box'
      let offset = el.offsetHeight - el.clientHeight
      el.addEventListener('input', function (e) {
        e.target.style.height = 'auto'
        e.target.style.height = e.target.scrollHeight + offset + 'px'
      })
      // el.removeAttribute('data-autoresize')
    })
  }
}
